export class Step2 {
    constructor() {}

    intitule = 'stepper.form.dive_in.step1';


    gettravaux = 'form.dive_in.gettravaux';
    getconceptionrealisation = 'form.dive_in.getconceptionrealisation';
    getexecution = 'form.dive_in.getexecution';
    getfournitures = 'form.dive_in.getfournitures';
    getachat = 'form.dive_in.getachat';
    getcreditbail = 'form.dive_in.getcreditbail';
    getlocation = 'form.dive_in.getlocation';
    getlocationvente = 'form.dive_in.getlocationvente';
    getservices = 'form.dive_in.getservices';
    getmarcheservices = 'form.dive_in.getmarcheservices';
    getspan1 = 'form.dive_in.getspan1';
    getspan2 = 'form.dive_in.getspan2';
    getnum = 'form.dive_in.getnum';
    gettypevoie = 'form.dive_in.gettypevoie';
    getnomvoie = 'form.dive_in.getnomvoie';
    getcp = 'form.dive_in.getcp';
    getville = 'form.dive_in.getville';
    getlieuexecutionlivraison = 'form.dive_in.getlieuexecutionlivraison';
    getmotclef_liste_avi_ = 'form.dive_in.getmotclef_liste_avi_';
    ajouter = 'form.dive_in.ajouter';
    supprimer = 'form.dive_in.supprimer';
    getspan21 = 'form.dive_in.getspan21';
    getspan22 = 'form.dive_in.getspan22';
    getspan23 = 'form.dive_in.getspan23';
    getclassprincipale = 'form.dive_in.getclassprincipale';
    getclasssupplementaire = 'form.dive_in.getclasssupplementaire';
    gettextelibre = 'form.dive_in.gettextelibre';
    getintitulelibre = 'form.dive_in.getintitulelibre';
    getintitulelibrelibelle = 'form.dive_in.getintitulelibrelibelle';

    public getobjet = 'form.mapa_at.getobjet';
    public getspan4 = 'form.mapa_at.getspan4';
}
